import { useQuery } from "@tanstack/react-query";
import { getContractByPropertyUid } from "../../api";

export const useGetContractByPropertyUid = (propertyUid: string) => {
  return useQuery({
    refetchOnWindowFocus: false,
    retry: false,
    queryKey: ["contract", propertyUid],
    queryFn: async () => {
      if (!propertyUid) {
        return null;
      }
      const response = await getContractByPropertyUid(propertyUid);
      return response.data;
    },
    enabled: !!propertyUid,
  });
};
